
interface Props {
    className?: string
    pathClassName?: string
    FillColor?: string
}

export default function Calendar({
                                  FillColor = '',
                                  className = '',
                                  pathClassName = ''
                              }: Props) {
    return (
        <svg viewBox="0 0 24 24" className={className}>
            <path
                d="M13.5 12.3C13.5 12.1343 13.3657 12 13.2 12H11.7C11.0373 12 10.5 12.5373 10.5 13.2C10.5 13.3657 10.6343 13.5 10.8 13.5H12.3C12.9627 13.5 13.5 12.9627 13.5 12.3Z"
                fill={FillColor}
                className={pathClassName}/>
            <path
                d="M19.2 12C19.3657 12 19.5 12.1343 19.5 12.3C19.5 12.9627 18.9627 13.5 18.3 13.5H16.8C16.6343 13.5 16.5 13.3657 16.5 13.2C16.5 12.5373 17.0373 12 17.7 12H19.2Z"
                fill={FillColor}
                className={pathClassName}/>
            <path
                d="M19.2 15C19.3657 15 19.5 15.1343 19.5 15.3C19.5 15.9627 18.9627 16.5 18.3 16.5H16.8C16.6343 16.5 16.5 16.3657 16.5 16.2C16.5 15.5373 17.0373 15 17.7 15H19.2Z"
                fill={FillColor}
                className={pathClassName}/>
            <path
                d="M13.2 15C13.3657 15 13.5 15.1343 13.5 15.3C13.5 15.9627 12.9627 16.5 12.3 16.5H10.8C10.6343 16.5 10.5 16.3657 10.5 16.2C10.5 15.5373 11.0373 15 11.7 15H13.2Z"
                fill={FillColor}
                className={pathClassName}/>
            <path
                d="M13.5 18.3C13.5 18.1343 13.3657 18 13.2 18H11.7C11.0373 18 10.5 18.5373 10.5 19.2C10.5 19.3657 10.6343 19.5 10.8 19.5H12.3C12.9627 19.5 13.5 18.9627 13.5 18.3Z"
                fill={FillColor}
                className={pathClassName}/>
            <path
                d="M7.2 12C7.36569 12 7.5 12.1343 7.5 12.3C7.5 12.9627 6.96274 13.5 6.3 13.5H4.8C4.63431 13.5 4.5 13.3657 4.5 13.2C4.5 12.5373 5.03726 12 5.7 12H7.2Z"
                fill={FillColor}
                className={pathClassName}/>
            <path
                d="M7.5 15.3C7.5 15.1343 7.36569 15 7.2 15H5.7C5.03726 15 4.5 15.5373 4.5 16.2C4.5 16.3657 4.63431 16.5 4.8 16.5H6.3C6.96274 16.5 7.5 15.9627 7.5 15.3Z"
                fill={FillColor}
                className={pathClassName}/>
            <path
                d="M7.2 18C7.36569 18 7.5 18.1343 7.5 18.3C7.5 18.9627 6.96274 19.5 6.3 19.5H4.8C4.63431 19.5 4.5 19.3657 4.5 19.2C4.5 18.5373 5.03726 18 5.7 18H7.2Z"
                fill={FillColor}
                className={pathClassName}/>
            <path
                d="M6 4.05C6 3.88431 6.13431 3.75 6.3 3.75C6.96274 3.75 7.5 4.28726 7.5 4.95V6H16.5V4.05C16.5 3.88431 16.6343 3.75 16.8 3.75C17.4627 3.75 18 4.28726 18 4.95V6H20.25C21.4926 6 22.5 7.00736 22.5 8.25V20.25C22.5 21.4926 21.4926 22.5 20.25 22.5H3.75C2.50736 22.5 1.5 21.4926 1.5 20.25V8.25C1.5 7.00736 2.50736 6 3.75 6H6V4.05ZM6 7.5H3.75C3.33579 7.5 3 7.83579 3 8.25V20.25C3 20.6642 3.33579 21 3.75 21H20.25C20.6642 21 21 20.6642 21 20.25V8.25C21 7.83579 20.6642 7.5 20.25 7.5H18V9.45C18 9.61569 17.8657 9.75 17.7 9.75C17.0373 9.75 16.5 9.21274 16.5 8.55V7.5H7.5V9.45C7.5 9.61569 7.36569 9.75 7.2 9.75C6.53726 9.75 6 9.21274 6 8.55V7.5Z"
                fill={FillColor}
                className={pathClassName}/>

        </svg>
    )
}
